module.exports = __webpack_public_path__ + "static/images/styles/images/landing/landing-award-small.1a08ae0e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/landing/landing-award-small.png
// module id = 3652
// module chunks = 11